"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = require("./store");
async function default_1(name, data) {
    const listeners = (0, store_1.getListeners)(name);
    let results = [];
    for (const listener of listeners) {
        const result = await listener(data);
        results.push(result);
    }
    return results;
}
exports.default = default_1;
//# sourceMappingURL=fireEvent.js.map